import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { Channel } from '@src/api/shared/community/channelApiClient';
import {
  chatApiClient,
  ChatThreadIndexResponse,
  ThreadChat,
} from '@src/api/shared/community/chatApiClient';

interface ThreadState {
  parentChat: ThreadChat | undefined;
  threadReplies: ThreadChat[];
  firstUnreadThreadChatId: number | null;
  isPolling: boolean;
  pollingIntervalId: NodeJS.Timeout | null;
}

interface FetchThreadParams {
  channel: Channel | null;
  parentChatId: number;
  markAsRead?: boolean;
}

export const fetchThreads = createAsyncThunk(
  'thread/fetchData',
  async ({ channel, parentChatId, markAsRead }: FetchThreadParams) => {
    const res = await chatApiClient.threads(channel?.code ?? '', parentChatId, {
      mark_as_read: markAsRead ?? false,
    });
    let threadData: ChatThreadIndexResponse | undefined;

    handleApiResponse(res, (data) => {
      threadData = data;
    });

    return threadData;
  },
);

const threadSlice = createSlice({
  name: 'thread',
  initialState: {
    parentChat: undefined,
    threadReplies: [],
    firstUnreadThreadChatId: null,
    isPolling: false,
    pollingIntervalId: null,
  } as ThreadState,
  reducers: {
    clearThreadData: (state) => {
      state.parentChat = undefined;
      state.threadReplies = [];
      state.firstUnreadThreadChatId = null;
      state.isPolling = false;
      if (state.pollingIntervalId) {
        clearInterval(state.pollingIntervalId);
        state.pollingIntervalId = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchThreads.fulfilled, (state, action) => {
      if (action.payload) {
        // ChatThreadIndexResponseから親チャットデータ、スレッド返信、未読情報を分離
        const { threads, first_unread_thread_chat_id, ...parentChatData } = action.payload;
        state.parentChat = parentChatData as ThreadChat;
        state.threadReplies = threads;
        state.firstUnreadThreadChatId = first_unread_thread_chat_id;
      }
    });
  },
});

export const { clearThreadData } = threadSlice.actions;
export default threadSlice.reducer;
